<template>
  <div id="app">
    <div class="h1">
      <div class="w">
        <img
          @click="to_xaizai()"
          src="../../assets/img/pagess/gdd118/01btn.gif"
          alt=""
        />
      </div>
    </div>
    <div class="h2">
      <div class="paoma">
        <el-carousel height="625px" indicator-position="outside">
          <el-carousel-item>
            <img src="../../assets/img/pagess/gdd118/01111.png" alt="" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/img/pagess/gdd118/02222.png" alt="" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/img/pagess/gdd118/0333.png" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="h3">
      <div class="w">
        <img
          @click="to_xaizai()"
          src="../../assets/img/pagess/gdd118/btn2.gif"
          alt=""
        />
      </div>
    </div>
    <div class="h4">
      <div class="w">
        <img
          @click="to_xaizai()"
          src="../../assets/img/pagess/gdd118/btn2.gif"
          alt=""
        />
      </div>
    </div>
    <div class="h5">
      <div class="w">
        <img
          @click="to_xaizai()"
          src="../../assets/img/pagess/gdd118/btn2.gif"
          alt=""
        />
      </div>
    </div>

    <div class="bottomss">
      <p>————&nbsp;投资有风险入市需谨慎&nbsp;————</p>
      <p>
        从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp;
        合法机构名单可到中国证监会网站 (<a href="http://www.csrc.gov.cn/"
          >www.csrc.gov.cn</a
        >)查询
      </p>
      <p>
        北京天相财富管理顾问有限公司&nbsp;&nbsp;&nbsp;
        <a href="https://beian.miit.gov.cn/">京ICP备16068579号-2</a
        >&nbsp;&nbsp;&nbsp; 执证编号：91110102MA001GJE1N
      </p>
      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年2月</p>
      <p style="text-decoration: underline; cursor: pointer" class="qwer">
        <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        <span @click="open_yinsi()" style="margin-right: 10px"
          >隐私保护政策</span
        >
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>
      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
    <!-- <div class="box"></div>
    <div class="bar">
      <div class="w">
        <img @click="to_xaizai()" src="../../assets/img/pagess/gdd118/btn3.gif" alt="" />
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  data() {
    return {};
  },

  mounted() {
    this.clientIp();
  },

  methods: {
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          url: window.location.href,
          qhclickid: "cf2",
          code: this.$route.query.code,
          type: "cpc",
        })
        .then((res) => {
           
        });
    },
    open_yinsi() {
      window.open("https://ins.juniubang.com/images/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://ins.juniubang.com/images/应用权限4.7.pdf");
    },
    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then((res) => {
          window.localStorage.setItem("_number", res.data);
        });
    },
    to_xaizai() {
      this.post_leilei_data();
      // window.open("https://cdn.juniubang.com/apk/GDD2002.exe");
      window.open("https://cdn.juniubang.com/apk/GDD1001.exe");
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  height: 200px;
  width: 100%;
  background-color: #fdf3ea;
}
.bar {
  width: 100%;
  height: 185px;
  background: url(../../assets/img/pagess/gdd118/bar.png);
  background-size: 100% 100%;
  position: fixed;
  bottom: 0;
  z-index: 999;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.h1 {
  width: 100%;
  height: 1257px;
  background: url(../../assets/img/pagess/gdd118/01_01.png);
  background-size: 100% 100%;
  .w {
    width: 100px;
    margin: 0 auto;
    position: relative;
    img {
      width: 600px;
      position: absolute;
      left: 50%;
      margin-left: -300px;
      top: 500px;
    }
  }
}
.h2 {
  width: 100%;
  height: 876px;
  background: url(../../assets/img/pagess/gdd118/01_02.jpg);
  background-size: 100% 100%;
  position: relative;
  .paoma {
    width: 1049px;
    margin: 0 auto;
    height: 625px;

    position: absolute;
    top: 330px;
    left: 50%;
    margin-left: -525px;
  }
}
.h3 {
  width: 100%;
  height: 876px;
  background: url(../../assets/img/pagess/gdd118/01_03.jpg);
  background-size: 100% 100%;
  .w {
    width: 100px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      left: 50%;
      margin-left: 110px;
      top: 780px;
    }
  }
}
.h4 {
  width: 100%;
  height: 876px;
  background: url(../../assets/img/pagess/gdd118/01_04.jpg);
  background-size: 100% 100%;
  .w {
    width: 100px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      left: -500px;
      top: 630px;
    }
  }
}
.h5 {
  width: 100%;
  height: 876px;
  background: url(../../assets/img/pagess/gdd118/01_05.jpg);
  background-size: 100% 100%;
  .w {
    width: 100px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      left: 50%;
      margin-left: 110px;
      top: 480px;
    }
  }
}
.box {
  width: 100%;
  height: 170px;
}
.bottomss {
  width: 100%;
  height: 150px;
  background-color: #fdf3ea;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  .boxx {
    width: 100%;
    height: 30px;
  }
  .qwer span:hover {
    color: #333;
  }
  a {
    font-size: 12px;
    color: #333;
  }
  p {
    margin: 0;
    font-size: 12px;
    color: #6e7a9e;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd118.vue